// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
require('./_set-collection-from')('Set');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es7.set.from.js
// module id = 1784
// module chunks = 0